import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { CHECKOUT_URL, price } from '../data/offer';
import { trackPixelEvent } from '../utils/pixel';
type CTAButtonProps = {
  className?: string;
  label?: string;
};
export function CTAButton({
  className = '',
  label = '¡QUIERO SER UN ATLETA HÍBRIDO AHORA — ACCESO POR $17.990!'
}: CTAButtonProps) {
  const handleClick = () => {
    trackPixelEvent('InitiateCheckout', {
      content_name: 'Método Híbrido 2.0',
      value: price,
      currency: 'ARS'
    });
  };
  return <a href={CHECKOUT_URL} target="_blank" rel="noopener noreferrer" onClick={handleClick} className={`group inline-flex w-full items-center justify-center gap-3 rounded-lg bg-flame-500 px-6 py-5 text-center font-display text-xl font-extrabold uppercase italic tracking-wide text-white shadow-[0_10px_0_0_#9c2a08] transition-all hover:bg-flame-400 hover:shadow-[0_6px_0_0_#9c2a08] active:translate-y-1 active:shadow-[0_2px_0_0_#9c2a08] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-volt sm:text-2xl ${className}`} data-id="element-12" data-mp="2ozqh3mqs37b1">
      <span className="text-balance" data-id="element-13" data-mp="1db05gom8vz2j">{label}</span>
      <ArrowRightIcon className="hidden h-6 w-6 shrink-0 transition-transform group-hover:translate-x-1 sm:block" aria-hidden="true" data-id="element-14" data-mp="1i9urdzfie3qv" />
    </a>;
}